import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Events as GenericEvents } from '../../../../services/events/events';
import { Commands } from '../commands/commands';

@Injectable({
  providedIn: 'root'
})
export class Events extends GenericEvents {

  constructor(protected override commands: Commands){
    super(commands, 'mind-link');
  }

  public onGameStart(): Observable<any>{
    return this.on('game:started');
  }

  public onPlayerSelected(): Observable<any>{
    return this.on('player:selected');
  }

  public onRoundStart(): Observable<any>{
    return this.on('round:started');
  }

  public onRoundEnd(): Observable<any>{
    return this.on('round:ended');
  }

  public onPlayerLeft(): Observable<any>{
    return this.on('player:left');
  }

  public onWordPassed(): Observable<any>{
    return this.on('word:passed');
  }

  public onPointsUpdated(): Observable<any>{
    return this.on('points:updated');
  }

}
